export default __webpack_public_path__ + "static/media/update.c416a9c7.png";